import { STATUS, DECISION_COLOR } from '../logik/model.js';

export function Legend({ data }: { data: any }) {
  return (
    <div className="legend" data-testid="legend">
      <div className="cols">
        <div className="sec">
          <h4>Verbindungen</h4>
          {data.edgeTypes.map((t: any) => (
            <div className="it" key={t.id} title={t.beschreibung || ''}>
              <svg width="30" height="8"><line x1="0" y1="4" x2="30" y2="4" stroke={t.farbe} strokeWidth={t.breite || 1.6} strokeDasharray={t.dash || ''} /></svg>{t.name}
            </div>
          ))}
        </div>
        <div>
          <div className="sec">
            <h4>Status</h4>
            {STATUS.map((s: any) => <div className="it" key={s.id}><svg width="12" height="12"><circle cx="6" cy="6" r="5" fill={s.farbe} /></svg>{s.name}</div>)}
          </div>
          <div className="sec">
            <h4>Kennzeichen</h4>
            <div className="it"><svg width="30" height="14"><rect x="1" y="1" width="28" height="12" rx="3" fill="none" stroke={DECISION_COLOR} strokeWidth="2" strokeDasharray="4 2" /></svg>Offene Entscheidung</div>
            <div className="it"><svg width="30" height="14"><rect x="1" y="1" width="28" height="12" rx="6" fill="var(--pa-chip)" stroke="var(--pa-accent)" /><text transform="translate(15,10) scale(0.25)" fontSize="28" textAnchor="middle" fontWeight="700" fill="var(--pa-accent)">AS 2</text></svg>Ausbaustufe 2</div>
            <div className="it"><svg width="30" height="14"><rect x="1" y="1" width="28" height="12" rx="3" fill="none" stroke="var(--pa-node-stroke)" /><rect x="3" y="3" width="24" height="8" rx="2" fill="none" stroke="var(--pa-node-stroke)" /></svg>Unterprozess (⊞ öffnen)</div>
          </div>
        </div>
      </div>
    </div>
  );
}
